import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import axiosInstance from "../axios/axios";
import Loader from "./Loader";
import { useTranslate } from "./TranslationText";
import ActionButton from "./ActionButton";
import NetaqInput from "./NetaqInput";
import { getOrdinal } from "../helper/getOrdinal";
import { convertToCamelCase } from "../helper/convertToCamelCase";
import Popup from "reactjs-popup";
import UploadFile from "./SimpleFileUpload";
import { extractChars } from "../helper/extractChart";
import { Link } from "react-router-dom";
import PillBtn from "./PillBtn";
import EahsForm from "./EahsForm";
import { eFormButtonsContainer, eformInput, noDataCard } from "../common/cssclasses";
import NewActionButton from "./ActionButtons/NewActionButton";
import DraftBtn from "./servicesButtons/DraftBtn";
import SubmitServiceBtn from "./servicesButtons/SubmitServiceBtn";
import CustomSecondPopUp from "./CustomSecondPopUp";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";

export default function ParticipateHistory({ toast }) {
  const { translate } = useTranslate();
  const [ParticipateHistory, setParticipateHistory] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [skip, setSkip] = useState(0);
  const itemsPerPage = 20;
  const [take, settake] = useState(itemsPerPage);
  const [searchByHorseName, setSearchByHorseName] = useState(null);
  const [searchByShowName, setSearchByShowName] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [appliedSearchByHorseName, setAppliedSearchByHorseName] = useState(null);
  const [appliedSearchByShowName, setAppliedSearchByShowName] = useState(null);
  const [appliedFromDate, setAppliedFromDate] = useState(null);
  const [appliedToDate, setAppliedToDate] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [ParticipateLoaded, setParticipatesLoaded] = useState(false);
  const [noParticipatesFound, setNoParticipatesFound] = useState(false);
  const [triggerFetch, setTriggerFetch] = useState(0);

  const lang = localStorage.getItem('eahsLang') ?? 'en';

  async function getParticipateHistory() {
    try {
      setParticipatesLoaded(false);
      const response = await axiosInstance.post(
        "shows/FilterShowParticipantHistory", {
        skip: skip,
        take: take,
        showName: appliedSearchByShowName,
        horseName: appliedSearchByHorseName,
        startDate: appliedFromDate?.toDate(),
        endDate: appliedToDate?.toDate()
      }
      );
      if (response.data.responseCode === "200") {
        const Participates = response.data.result;
        setTotalCount(response.data.totalCount);
        setParticipateHistory(Participates);
        setNoParticipatesFound(Participates.length === 0);
        setParticipatesLoaded(true);
      } else {
        console.log("error in loading Participates");
        setParticipatesLoaded(true);
      }
    } catch (error) {
      console.log("error in loading Participates", error);
      setParticipatesLoaded(true);
    }
  }

  useEffect(() => {
    getParticipateHistory();
  }, [skip, triggerFetch]); // Fetch data on `skip` change for pagination or triggerFetch for search

  const handleReset = () => {
    setSearchByHorseName('');
    setSearchByShowName('');
    setFromDate(null);
    setToDate(null);

    setAppliedSearchByHorseName('');
    setAppliedSearchByShowName('');
    setAppliedFromDate(null);
    setAppliedToDate(null);

    setSkip(0);
    setCurrentPage(1);

    setParticipatesLoaded(false);
    // Fetch data without filters after resetting
    axiosInstance.post("shows/FilterShowParticipantHistory", {
      skip: 0,
      take: itemsPerPage,
      showName: null,
      horseName: null,
      startDate: null,
      endDate: null
    })
      .then(response => {
        if (response.data.responseCode === "200") {
          const Participates = response.data.result;
          setTotalCount(response.data.totalCount);
          setParticipateHistory(Participates);
          setNoParticipatesFound(Participates.length === 0);
        } else {
          console.log("error in loading Participates");
        }
      })
      .catch(error => {
        console.log("error in loading Participates", error);
      })
      .finally(() => {
        setParticipatesLoaded(true);
      });
  };

  const handleSubmit = () => {
    setAppliedSearchByHorseName(searchByHorseName);
    setAppliedSearchByShowName(searchByShowName);
    setAppliedFromDate(fromDate);
    setAppliedToDate(toDate);
    
    setSkip(0);
    setCurrentPage(1);
    setTriggerFetch(prev => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      setSkip((newPage - 1) * itemsPerPage);
    }
  };

  const handleNextPage = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      setSkip(newPage * itemsPerPage - itemsPerPage);
    }
  };

  // withdrawRequest
  const [withdrawReason, setWithDrawReason] = useState('');
  const [isSendingRequest, setIsSendingRequest] = useState(false);
  const [midicalReportFile, setMidicalReportFile] = useState([]);
  const [ismidicalReason, setIsMidicalReason] = useState(true);
  const handleUploadFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let checkFileSize = true;
      const fileListHook = [];

      for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
        if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
          checkFileSize = false;
          toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
        } else {
          fileListHook.push({
            documentFile: URL.createObjectURL(e.target.files[fileIndex]),
            name: e.target.files[fileIndex].name,
            file: e.target.files[fileIndex],
          });
        }
      }

      setMidicalReportFile(fileListHook);
    }
  };
  async function addWithdrawRequestWhileRegisterIsOpen(id, close) {
    try {
      if (!withdrawReason || !withdrawReason.trim()) {
        toast.error(translate('web.withdrawReason') + " " + translate('web.isRequired'));
        return;
      }
      setIsSendingRequest(true);
      const formData = new FormData();
      formData.append('id', id);
      formData.append('withdrawReason', withdrawReason);
      const response = await axiosInstance.post('showentry/createwithdrawrequest', formData, {
        headers: {
          'content-type': 'multipart/form-data',
        }
      });
      if (response.data.responseCode == '200') {
        toast.success(translate('web.yourRequestIsSentSuccessfully', 'Your Request Is Sent Successfully'));
        handleReset();
        setMidicalReportFile([]);
        setWithDrawReason('');
        close?.();
      } else {
        toast.error(translate('web.unexpectedError', 'Unexpected Error Please Contact the Admin'));
      }
    } catch (error) {
      toast.error(translate('web.unexpectedError', 'Unexpected Error Please Contact the Admin'));
    } finally {
      setIsSendingRequest(false);
    }
  }
  async function addWithdrawRequestWhileRegisterIsclosed(id, close) {
    try {
      if (ismidicalReason == true) {
        if (!midicalReportFile || midicalReportFile.length === 0) {
          toast.error(translate('web.medicalReportIsRequired', 'Medical Report Is Required'));
          return;
        }
      }
      if (!withdrawReason || !withdrawReason.trim()) {
        toast.error(translate('web.withdrawReason') + " " + translate('web.isRequired'));
        return;
      }
      setIsSendingRequest(true);
      const formData = new FormData();
      formData.append('id', id);
      formData.append('withdrawReason', withdrawReason);
      if (!!midicalReportFile && midicalReportFile.length > 0) {
        formData.append('withdrawAttachmentFile', midicalReportFile[0]?.file);
      }
      formData.append('isMedicalWithdraw', ismidicalReason);
      const response = await axiosInstance.post('showentry/createwithdrawrequest', formData, {
        headers: {
          'content-type': 'multipart/form-data',
        }
      });

      if (response.data.responseCode == '200') {
        toast.success(translate('web.yourRequestIsSentSuccessfully', 'Your Request Is Sent Successfully'));
        handleReset();
        setMidicalReportFile([]);
        setWithDrawReason('');
        close?.();
      } else {
        toast.error(translate('web.unexpectedError', 'Unexpected Error Please Contact the Admin'));
      }
    } catch (error) {
      toast.error(translate('web.unexpectedError', 'Unexpected Error Please Contact the Admin'));
    } finally {
      setIsSendingRequest(false);
    }
  }

  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12">

        <EahsForm className={'mb-main'} title={translate("web.participateHistory", "Participate History")}>
            <div className={eformInput}>
              <NetaqInput
                type={"text"}
                label={translate("web.horseName", "Horse Name")}
                placeholder={translate("web.horseName", "Horse Name")}
                onChange={(e) => setSearchByHorseName(e.target.value)}
                value={searchByHorseName}
                name={translate("web.horseName", "Horse Name")}
              />
            </div>
            <div className={eformInput}>
              <NetaqInput
                type={"text"}
                label={translate("web.showName", "Show Name")}
                placeholder={translate("web.showName", "Show Name")}
                onChange={(e) => setSearchByShowName(e.target.value)}
                value={searchByShowName}
                name={translate("web.showName", "Show Name")}
              />
            </div>
            <div className={eformInput} >
              <NetaqInput
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e)}
                label={translate("web.from", "From")}
                name={translate("web.from", "From")}
                maxDate={toDate || dayjs()}
              />
            </div>
            <div className={eformInput} >
              <NetaqInput
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e)}
                label={translate("web.to", "To")}
                name={translate("web.to", "To")}
                minDate={fromDate}
                maxDate={dayjs()}
              />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12 ms-auto" onClick={handleReset}>
              <NewActionButton
                classNames="btn-outline-secondary"
                isButton
                type={'reset'}
                text={translate("web.reset", "Reset")}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 " onClick={handleSubmit}>
              <NewActionButton
                classNames="btn-danger"
                isButton
                type={'submit'}
                text={translate("web.search", "Search")}
              />
            </div>
          </EahsForm>



          {ParticipateLoaded ? (
            ParticipateHistory.length > 0 ? (
              <div className="scrolableTable">
              <table className="table table-striped table-bordered rtl horseResultTable mb-main">
                <thead className="theadHorseSelect">
                  <tr>
                    <th className="text-center">
                      {translate("web.horseName", "Horse Name")}
                    </th>
                    <th className="text-center">
                      {translate("web.showName", "Show Name")}
                    </th>
                    <th className="text-center">
                      {translate("web.showrank", "Show Rank")}
                    </th>
                    <th className="text-center">
                      {translate("web.showDate", "Show Date")}
                    </th>
                    <th className="text-center">
                      {translate("web.categories", "Categories")} / {translate("web.classes", "Classes")}
                    </th>
                    <th className="text-center">
                      {translate("web.rank", "Rank")}
                    </th>
                    <th className="text-center">
                      {translate("web.medal", "Medal")}
                    </th>
                    <th className="text-center">
                      {translate("web.withdrawStatus", "Withdraw Status")}
                    </th>
                    <th className="text-center">
                      {translate("web.viewCatalog", "View Catalog")}
                    </th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {ParticipateHistory.map((item, index) => (
                    <tr key={index}>
                      <td className="rtl">{item.horseName}</td>
                      <td className="rtl" >{item.showName}</td>
                      <td className="rtl">{item.showRank}</td>
                      <td className="rtl">{formatDateTimeToString(item?.showStartDateObject)}</td>
                      <td className="rtl">{item.categoryClassName}</td>
                      <td className="rtl" dangerouslySetInnerHTML={{ __html: !!item.rank ? getOrdinal(item.rank, lang) : '' }}></td>
                      <td className="rtl">{!!item.medal ? translate(`web.${convertToCamelCase(item.medal)}`, item.medal) : ''}</td>
                      <td className="rtl">
                        {(item.withdrawStatus == 'None' && item.withdrawStatus != null) ? <>{translate(`web.${convertToCamelCase(item.withdrawStatus)}`, item.withdrawStatus)}</>
                          :
                          <>
                            {item.isAllowedToRequest ?
                              <CustomSecondPopUp
                                title={translate('web.addWithdrawRequest', 'Add Withdraw Request')}
                                onClose={item.isShowRegisterOpend ? () => { handleSubmit(); setWithDrawReason(''); } : () => { setWithDrawReason(''); setMidicalReportFile([]); }}
                                onSave={isSendingRequest ? undefined : (item.isShowRegisterOpend ? (close) => addWithdrawRequestWhileRegisterIsOpen(item.id, close) : (close) => addWithdrawRequestWhileRegisterIsclosed(item.id, close))}
                                autoCloseOnSave={false}
                                isDisabled={isSendingRequest}
                                closePopUp={!isSendingRequest}
                                closeOnEscape={!isSendingRequest}
                                trigger={lang == 'en' ? <ActionButton type={'normalbtn'} className="tooltip" text={`<i class="fa-solid fa-right-from-bracket w-unset"></i><span class="tooltiptext" style="left:-100px !important;">Withdraw Request</span>`} /> : <ActionButton type={'normalbtn'} className="tooltip" text={`<i class="fa-solid fa-right-from-bracket w-unset"></i><span class="tooltiptext" style="right:-100px !important;">طلب انسحاب</span>`} />}>
                                {isSendingRequest ? (
                                  <div className="py-4 text-center">
                                    <Loader />
                                  </div>
                                ) : (
                                  item.isShowRegisterOpend ?
                                    <>
                                      <form className="row  text-start rtl" onSubmit={(e) => { e.preventDefault(); }}>
                                        <div className="row mx-0  rtl   py-2 " >
                                          <NetaqInput textareaRows={3} textAreaHeight="50px" label={translate('web.withdrawReason', 'withdrawReason')} type={'textarea'} onChange={(e) => setWithDrawReason(e.target.value)} required={true} name={'withdrawReason'} />
                                        </div>
                                      </form>
                                    </>
                                    :
                                    <>
                                      <form className="row text-start rtl " onSubmit={(e) => { e.preventDefault(); }}>
                                        <div className="row rtl   pb-2 hourseCardClass" >
                                          <div className="d-flex my-2">
                                            <div>
                                              <NetaqInput label={translate('web.isMidicalReason', 'Is Midical Reason')} type={'radio'} onChange={(e) => setIsMidicalReason(true)} required={true} checked={ismidicalReason} name={'withdrawReason'} />
                                            </div>
                                          </div>
                                          <div className="col-md-6 col-sm-12 mt-2">
                                            <NetaqInput textareaRows={3} textAreaHeight="40.4px" label={translate('web.withdrawReason', 'withdrawReason')} type={'textarea'} onChange={(e) => setWithDrawReason(e.target.value)} required={true} name={'withdrawReason'} />
                                          </div>
                                          <div className="col-md-6 col-sm-12 mt-2">
                                            <label>{translate('web.midicalReport', 'Medical Report')} {ismidicalReason ? <span style={{ color: 'red' }}>*</span> : ''} </label>
                                            <UploadFile
                                              key={'anykey' + index}
                                              initialFiles={midicalReportFile}
                                              text={translate('web.uploadMedicalReport', 'Upload Medical Report')}
                                              ismultiFile={false}
                                              isServer={false}
                                              name={`medicalreport`}
                                              className="text-center "
                                              onChange={(e) => handleUploadFile(e)}
                                            />

                                          </div>
                                        </div>

                                      </form>

                                    </>

                                )}

                              </CustomSecondPopUp>
                              : <>{translate(`web.${convertToCamelCase(item.withdrawStatus)}`, item.withdrawStatus)}</>
                            }
                          </>}

                      </td>
                      <td className="rtl">
                        {!!item?.showId && item?.isShowDigitalCatalog == true &&
                          <ActionButton type={'openLink'} to={`/digitalCatalog?showId=${item?.showId}`} title={translate('web.viewCatalog', 'viewCatalog')}
                            text={`
                          <i title=${translate('web.viewCatalog', 'viewCatalog')} class="fa-solid fa fa-eye w-unset" />
                          `}
                          />
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>


              <div className="pagination-buttons rtl" >
                <NewActionButton
                  classNames="btn-outline-danger w-unset"
                  key={'perv'}
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  text={translate("web.previous", "Previous")}
                />
                <NewActionButton
                  classNames="btn-danger w-unset  ms-2"
                  key={'pages'}
                  text={`${currentPage} / ${Math.ceil(totalCount / itemsPerPage)}`}
                />
                <NewActionButton
                  key={'next'}
                  classNames="btn-outline-danger w-unset ms-2"
                  onClick={handleNextPage}
                  disabled={currentPage === Math.ceil(totalCount / itemsPerPage)}
                  text={translate("web.next", "Next")}
                />
              </div>
            </div>
          ) : (
            <div className={noDataCard}>
              {translate("web.nodataFound", "No Result Found")}
            </div>
          )) : (
            <Loader />
          )}
        </div>
    </>
  );
}
